module.exports = __webpack_public_path__ + "static/assets/bc3e88cc87e897172b642b2bb618d7b5.svg";